import Vue from 'vue'
import animated from 'animate.css'
Vue.use(animated)
import 'amfe-flexible' // 自动计算font-size。屏幕分辨率自适应

// vantUI
import {
  Button,
  Swipe,
  SwipeItem,
  Skeleton,
  Icon,
  Sidebar,
  SidebarItem,
  Uploader,
  Field,
  Form,
  Calendar,
  Cell,
  CellGroup,
  AddressList,
  Popup,
  Toast,
  Dialog,
  NavBar,
  Search,
  NoticeBar,
  Step,
  Steps,
  Tab,
  Tabs,
  Empty,
  Rate,
  Image as VanImage,
  Loading,
  Lazyload,
  PullRefresh,
  Checkbox,
  CheckboxGroup,
  Tag,
  Overlay,
  DatetimePicker,
  List,
  Card,
  Divider,
  Badge
} from 'vant'
Vue.use(Button)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Skeleton)
Vue.use(Icon)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Uploader)
Vue.use(Field)
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(AddressList)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(NavBar)
Vue.use(Search)
Vue.use(NoticeBar)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Empty)
Vue.use(Rate)
Vue.use(VanImage)
Vue.use(Loading)
Vue.use(Lazyload)
Vue.use(PullRefresh)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tag)
Vue.use(Overlay)
Vue.use(DatetimePicker)
Vue.use(List)
Vue.use(Card)
Vue.use(Divider)
Vue.use(Badge)
Vue.use(Form)
